import React from 'react';
import { useTheme } from '../context/ThemeContext';

const CustomLegend = ({ payload }) => {
  const { isDarkMode } = useTheme();

  if (!payload || !payload.length) {
    return null;
  }

  return (
    <div
      className="flex flex-wrap justify-center items-center p-3 rounded-xl mx-auto max-w-fit"
      style={{
        background: 'transparent',
      }}
    >
      {payload.map((entry, index) => (
        <div
          key={index}
          className="flex items-center mx-2 my-1 text-sm font-medium"
          style={{ color: isDarkMode ? '#fafafa' : '#1f2937' }}
        >
          <span
            className="inline-block w-3 h-3 rounded-full mr-2 shadow-sm"
            style={{ backgroundColor: entry.color }}
          ></span>
          <span>{entry.value}</span>
        </div>
      ))}
    </div>
  );
};

export default CustomLegend;